import request from '@/utils/request';
// 获取表决人员详情列表
const getVoteGroupList = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee-group/list`,
        method: 'get',
        params
    });
};
// 获取表决人员详情列表数量
const getVoteGroupCount = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee-group/count`,
        method: 'get',
        params
    });
};
// 获取表决分组列表
const getGroupList = id => {
    return request({
        url: `/gathering/meeting/${id}/invitee-group/details/list`,
        method: 'get'
    });
};
//删除表决分组
const deleteVoteGroup = (meeting_id, groupId) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/group/${groupId}`,
        method: 'delete'
    });
};

// 实时获取会议表决项
const getRealTimeVoteList = id => {
    return request({
        url: `/cache/court-live/votes/${id}.json`,
        method: 'get'
    });
};
// 投票表决
const voteByBallot = params => {
    return request({
        url: `/gathering/vote-record`,
        method: 'post',
        data: params
    });
};
// 投票表决
const voteByBallotAll = params => {
    return request({
        url: `/gathering/vote-record/all`,
        method: 'post',
        data: params
    });
};

// 获取代理人该表决下所代理的债权人信息
const voteByBallotVoteId = params => {
    return request({
        url: `/gathering/vote-record/${params.voteId}`,
        method: 'post',
        data: params
    });
};
// 获取人员组别
const getUserGrouping = (meeting_id, userId) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/invitee/${userId}/group`,
        method: 'get'
    });
};
// 获取分组组别
const getGroupData = id => {
    return request({
        url: `/gathering/meeting/${id}/group`,
        method: 'get'
    });
};
// 获取用户某个会议的投票记录
const getVotingRecords = params => {
    return request({
        url: `/gathering/vote-record/user/records`,
        method: 'get',
        params
    });
};

// 投票结束详情
const getVotingRecordsVoteId = params => {
    return request({
        url: `/gathering/vote-record/user/records/${params.voteId}/${params.meetingId}/${params.userId}`,
        method: 'get'
    });
};

// 获取用户某个会议的投票记录
const getVotingRecordsMeetingId = params => {
    return request({
        url: `/gathering/vote-record/meetingId/${params.meetingId}`,
        method: 'post',
        data: params
    });
};
// 导入人员分组
const importGroupUser = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee-group/import`,
        data: params,
        method: 'post'
    });
};
// 导入人员分组进度
const importProgress = (meeting_id, id) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/invitee-group/import/${id}`,
        method: 'get'
    });
};
// 获取会议文件列表
const getMeetingFiles = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/doc`,
        method: 'get',
        params
    });
};
const getMeetingFileCount = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/doc/count`,
        method: 'get',
        params
    });
};
// 获取视频文件
const getVideoList = id => {
    return request({
        url: `/gathering/meeting/${id}/doc/videos`,
        method: 'get'
    });
};
const downloadFile = id => {
    return request({
        url: `/sys/fs/${id}`,
        method: 'get'
    });
};
// 视频分片上传前
const beforeUploadStart = params => {
    return request({
        url: `/sys/fs/part-pre`,
        method: 'post',
        data: params
    });
};
// 视频分片上传中
const beforeUploading = params => {
    return request({
        url: `/sys/fs/part-file`,
        method: 'post',
        data: params
    });
};
// 视频分片上传后
const beforeUploadEnd = params => {
    return request({
        url: `/sys/fs/part-margin`,
        method: 'post',
        timeout: 86400000,
        data: params
    });
};
// 上传文件
const uploadFiles = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/doc`,
        method: 'post',
        data: params
    });
};

// 文件排序
const sortFiles = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/doc/ord`,
        method: 'put',
        data: params
    });
};
// 删除文件
const deleteFile = (meetingId, id) => {
    return request({
        url: `/gathering/meeting/${meetingId}/doc/${id}`,
        method: 'delete'
    });
};
// 新建表决
const addVote = params => {
    return request({
        url: `/gathering/vote`,
        method: 'post',
        data: params
    });
};
// 获取表决数量
const getVoteCount = params => {
    return request({
        url: `/gathering/vote/count`,
        method: 'get',
        params
    });
};
// 获取表决列表
const getVoteList = params => {
    return request({
        url: `/gathering/vote/list`,
        method: 'get',
        params
    });
};
// 编辑表决信息
const editVoteInfo = (id, params) => {
    return request({
        url: `/gathering/vote/${id}`,
        method: 'put',
        data: params
    });
};
// 编辑表决信息(简介和表名)
const editVoteLocalInfo = (id, params) => {
    return request({
        url: `/gathering/vote/${id}/simple-information`,
        method: 'put',
        data: params
    });
};
// 删除表决
const deleteVote = id => {
    return request({
        url: `/gathering/vote/${id}`,
        method: 'delete'
    });
};
// 获取表决详情
const getVoteDetail = id => {
    return request({
        url: `/gathering/vote/${id}`,
        method: 'get'
    });
};
// 开启表决
const beginVote = id => {
    return request({
        url: `/gathering/vote/${id}/began`,
        method: 'put'
    });
};
// 重开表决
const restartVote = id => {
    return request({
        url: `/gathering/vote/${id}/reBegan`,
        method: 'put'
    });
};
// 结束表决
const endVote = id => {
    return request({
        url: `/gathering/vote/${id}/ended`,
        method: 'put'
    });
};
// 获取投票的详细报告
const voteDetailReport = id => {
    return request({
        url: `/gathering/vote/${id}/report/details`,
        method: 'get'
    });
};
// 获取表决结果详情数量
const getVoteResultCount = (id, params) => {
    return request({
        url: `/gathering/vote/${id}/report/count`,
        method: 'get',
        params
    });
};
// 获取表决结果详情列表
const getVoteResultList = (id, params) => {
    return request({
        url: `/gathering/vote/${id}/report/list`,
        method: 'get',
        params
    });
};
// 获取表决分组详情列表
const getGroupDetails = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/group/details`,
        method: 'get',
        params
    });
};
export {
	getGroupDetails,
    getVotingRecordsMeetingId,
    getGroupList,
    importGroupUser,
    importProgress,
    addVote,
    getVoteCount,
    getVoteList,
    editVoteInfo,
    editVoteLocalInfo,
    deleteVote,
    getGroupData,
    getMeetingFiles,
    downloadFile,
    getVideoList,
    deleteFile,
    uploadFiles,
    sortFiles,
    getVoteDetail,
    beginVote,
    endVote,
    getVoteGroupList,
    getVoteGroupCount,
    deleteVoteGroup,
    getMeetingFileCount,
    getRealTimeVoteList,
    getUserGrouping,
    voteByBallot,
    getVotingRecords,
    beforeUploadStart,
    beforeUploading,
    beforeUploadEnd,
    voteDetailReport,
    getVoteResultCount,
    getVoteResultList,
    voteByBallotVoteId,
    voteByBallotAll,
    getVotingRecordsVoteId,
    restartVote
};
